/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface FundingRequestPayoutRequestDto
 */
export interface FundingRequestPayoutRequestDto {
  /**
   *
   * @type {number}
   * @memberof FundingRequestPayoutRequestDto
   */
  amount: number;
  /**
   *
   * @type {string}
   * @memberof FundingRequestPayoutRequestDto
   */
  comment: string | null;
}

export function FundingRequestPayoutRequestDtoFromJSON(json: any): FundingRequestPayoutRequestDto {
  return FundingRequestPayoutRequestDtoFromJSONTyped(json, false);
}

export function FundingRequestPayoutRequestDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FundingRequestPayoutRequestDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    amount: json["amount"],
    comment: json["comment"],
  };
}

export function FundingRequestPayoutRequestDtoToJSON(value?: FundingRequestPayoutRequestDto | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    amount: value.amount,
    comment: value.comment,
  };
}
